module.exports = __webpack_public_path__ + "img/fiorino-oro-v1.e6955813.png";